import _classCallCheck from "@babel/runtime-corejs3/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime-corejs3/helpers/esm/createClass";
export var SoundBleep = /*#__PURE__*/function () {
  function SoundBleep() {
    _classCallCheck(this, SoundBleep);
    this.audio = document.createElement('audio');
    var source = document.createElement('source');
    if (this.audio.canPlayType('audio/mpeg;')) {
      source.type = 'audio/mpeg';
      source.src = 'static/highlight.mp3';
    } else {
      source.type = 'audio/ogg';
      source.src = 'static/highlight.ogg';
    }
    this.audio.appendChild(source);
  }
  return _createClass(SoundBleep, [{
    key: "play",
    value: function play() {
      this.audio.play();
    }
  }]);
}();